import React, { createContext, ReactElement, useContext, useMemo } from 'react'

import WebApp from '@twa-dev/sdk'
import { WebAppUser } from '@twa-dev/types'

interface UserContextValue {
    user?: WebAppUser
    webapp?: typeof WebApp
}

const UserContext = createContext<UserContextValue | undefined>(undefined)

type UserContextProps = React.PropsWithChildren<{
    initialUser?: WebAppUser
}>

export default function UserContextProvider({
    children,
    initialUser
}: UserContextProps): ReactElement {
    const value = useMemo(
        () => ({
            user: initialUser,
            webapp: WebApp
        }),
        [initialUser]
    )

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

export function useUserContext(): UserContextValue {
    const context = useContext(UserContext)
    if (!context) {
        throw new Error('useUserContext must be used within a UserProvider')
    }
    return context
}
